module.exports = __webpack_public_path__ + "workspace-switcher.png";